module.exports = __webpack_public_path__ + "img/SES_160254102.45f2865b.jpg";